import React from 'react'
import { Button } from 'src/components'
import { CowFaceIcon, TicketIcon, ClockIcon } from 'src/assets/svg'
import { IAnimal } from 'src/dto/animal.dto'
import { getAnimalAge } from '../../../utils/functions'
import { useStyles } from '../../styles'

interface AnimalInfoSectionProps {
  cowMother?: IAnimal | null
  onOpenHistory: () => void
}

export const AnimalInfoSection: React.FC<AnimalInfoSectionProps> = ({ cowMother, onOpenHistory }) => {
  const style = useStyles()

  return (
    <section className={style.section}>
      <div className={style.sectionHeader}>
        <div className={style.animalHeaderTitleRow}>
          <h2 className={style.sectionTitle}>Detalhes do Animal</h2>
        </div>
        <Button type='button' className={`${style.buttonWrapper}`} onClick={onOpenHistory}>
          Histórico reprodutivo
        </Button>
      </div>

      <div className={style.animalInfoGrid}>
        <div className={style.animalInfoItem}>
          <CowFaceIcon className={style.animalInfoIcon} />
          <div className={style.animalInfoContent}>
            <span className={style.animalInfoLabel}>Nome:</span>
            <strong className={style.animalInfoValue}>{cowMother?.nome || '-'}</strong>
          </div>
        </div>
        <div className={style.animalInfoItem}>
          <TicketIcon className={style.animalInfoIcon} />
          <div className={style.animalInfoContent}>
            <span className={style.animalInfoLabel}>Número:</span>
            <strong className={style.animalInfoValue}>{cowMother?.cdn || '-'}</strong>
          </div>
        </div>
        <div className={style.animalInfoItem}>
          <ClockIcon className={style.animalInfoIcon} />
          <div className={style.animalInfoContent}>
            <span className={style.animalInfoLabel}>Idade:</span>
            <strong className={style.animalInfoValue}>{getAnimalAge(cowMother?.dataNascimento)}</strong>
          </div>
        </div>
      </div>
    </section>
  )
}
